<template>
  <div class="symbol-search-index">
    <Filters
      :filters="symbolSearchFilters"
      filter-key="symbolSearch"
      :initial-data="filtersStatus.symbolSearch"
      :loading="filtersLoading"
    />

    <TableWrapper
      :table-columns="symbolSearchColumns"
      table-key="symbolSearch"
      row-key="tableId"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import { symbolSearchColumns, symbolSearchFilters } from '@/config';
  import { samplesApi } from '@/api';
  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import axios from 'axios';

  export default {
    name: 'SymbolSearchIndex',
    components: {
      Filters,
      TableWrapper,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    data() {
      return {
        symbolSearchColumns,
        symbolSearchFilters,
      };
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        try {
          const samplesSymbolsSearchIndex =
            await samplesApi.samplesSymbolsSearch(
              this.tableFilters('symbolSearch'),
              this.filtersStatus.symbolSearch,
              { signal }
            );
          const samplesSymbolsSearchCount =
            await samplesApi.samplesSymbolsSearchCount(
              this.filtersStatus.symbolSearch,
              { signal }
            );
          this.updateTableRows({
            tableKey: 'symbolSearch',
            rows: samplesSymbolsSearchIndex.data,
          });
          this.updateTableCount({
            tableKey: 'symbolSearch',
            count: samplesSymbolsSearchCount.data.count,
          });
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
    },
  };
</script>
